import React from "react";
import Tool from "./Tool";
import { observer } from "mobx-react";
import { observable } from "mobx";
import Utils from "./../../../utils/utils.js";

@observer
export default class SelectionTool extends Tool {
  @observable dragging = false;
  @observable dragStart = {};
  @observable selection = {};
  @observable overallSelection = {};
  selecting = false;
  moving = false;
  resizing = false;
  selectedElements = [];
  comeFromSelection = false;
  prevPositions = [];
  keys = [];
  @observable showAxis = "none"

  constructor(props) {
    super(props, 15, 20, "selection");
  }

  registerEvents() {
    return {
      mousemove: this.mouseMove.bind(this),
      mousedown: this.mouseDown.bind(this),
      mouseup: this.mouseUp.bind(this)
    };
  }

  showAxe(axis) {
    this.showAxis = axis;
  }

  getInput(key) {
    return this.toolbar.document.props.parent.getInput(key);
  }

  mouseDown(e) {
    if (e.button === 0) {
      let elAt = this.toolbar.document.getElementAt({
        x: e.clientX,
        y: e.clientY
      });

      if (elAt) {

        if(elAt.editing) return;

        if (!this.comeFromSelection && !this.getInput('Control')) {
          this.selectedElements = [];
          setTimeout(() => {
            this.toolbar.document.hideAllTransformControls();
            elAt.showTransformControls();
          }, 0);
        }

        this.select(elAt, this.getInput('Control'));
        elAt.showTransformControls();
        this.updateOverallSelection();
        this.startMove(e.clientX, e.clientY)
      } else {
        if(this.isSelectionAt(e.clientX, e.clientY)) {
          this.startMove(e.clientX, e.clientY)
        } else {
          this.toolbar.document.notifyPanel("selectionChanged", []);
          this.selectedElements = [];
          this.toolbar.document.hideAllTransformControls();
          this.updateOverallSelection();
        }
      }

      if (!elAt) {
        e.preventDefault();
        e.stopPropagation();

        this.dragging = true;
        this.selecting = true;
        this.dragStart = {
          x: e.clientX,
          y: e.clientY
        };
      }

      this.comeFromSelection = false;
      this.updateAll();
    }
  }

  startMove(x, y) {
    this.prevPositions = [];
    if(this.getSelection().length === 1)
      this.prevPositions.push(this.getSelection()[0].getPosition());
    else this.getSelection().filter(el => !el.hasParent()).forEach(s => this.prevPositions.push(s.getPosition()))
    this.OSStart = {
      x: this.overallSelection.startX,
      y: this.overallSelection.startY
    }
    this.dragging = true;
    this.moving = true;
    this.dragStart = {
      x,
      y
    };
  }

  updateAll(newEls) {}

  mouseMove(e) {
    if (this.dragging) {
      e.preventDefault();
      e.stopPropagation();
      const deltaX = e.clientX - this.dragStart.x;
      const deltaY = e.clientY - this.dragStart.y;

      if (this.moving && !this.resizing) {
        // const selection = this.getSelection()[0];
        const doc = this.toolbar.document;
        const docPos = doc.getDocumentPosition();
        const cont = doc.props.parent;
        const t = 4;

        const nextSelLeft = this.OSStart.x + deltaX / cont.zoom;
        const nextSelTop = this.OSStart.y + deltaY / cont.zoom;

        if(this.overallSelection.visibility === "visible") {
          const yAxis = nextSelLeft + this.overallSelection.width / 2 - t <= this.axis['Y'].x && this.axis['Y'].x <= nextSelLeft + this.overallSelection.width / 2 + t;
          const xAxis = nextSelTop + this.overallSelection.height / 2 - t <= this.axis['X'].y && this.axis['X'].y <= nextSelTop + this.overallSelection.height / 2 + t

          // console.log(nextSelLeft, nextSelTop, yAxis, xAxis);

          this.showAxe(xAxis && !yAxis ? "X" : (!xAxis && yAxis ? "Y": (xAxis && yAxis ? "XY": "none")));
        }

        const parentLessSel = (this.getSelection().length > 1 ? this.getSelection().filter(el => !el.hasParent()) : this.getSelection())

        for(let i = 0; i < parentLessSel.length; i++) {
          const sel = parentLessSel[i];
          const prevP = this.prevPositions[i];

          const nextLeft = prevP.x + deltaX / cont.zoom;
          const nextTop = prevP.y + deltaY / cont.zoom;


          // console.log(sel.x, this.axis['Y']);
          if(parentLessSel.length === 1) {
            const yAxis = nextLeft + sel.width / 2 - t <= this.axis['Y'].x - docPos.x && this.axis['Y'].x - docPos.x <= nextLeft + sel.width / 2 + t;
            const xAxis = nextTop + sel.height / 2 - t <= this.axis['X'].y - docPos.y && this.axis['X'].y - docPos.y <= nextTop + sel.height / 2 + t

            this.showAxe(xAxis && !yAxis ? "X" : (!xAxis && yAxis ? "Y": (xAxis && yAxis ? "XY": "none")));
            if(yAxis) {
              sel.setLeft(this.axis['Y'].x - docPos.x - sel.width / 2);
            } else {
              sel.setLeft(prevP.x + deltaX / cont.zoom);
            }
            if(xAxis) {
              sel.setTop(this.axis['X'].y - docPos.y - sel.height / 2);
            } else {
              sel.setTop(nextTop);
            }
          } else {
            // console.log(nextSelLeft, nextSelTop);
            const yAxis = nextSelLeft + this.overallSelection.width / 2 - t <= this.axis['Y'].x && this.axis['Y'].x <= nextSelLeft + this.overallSelection.width / 2 + t;
            const xAxis = nextSelTop + this.overallSelection.height / 2 - t <= this.axis['X'].y && this.axis['X'].y <= nextSelTop + this.overallSelection.height / 2 + t

            // console.log(xAxis, yAxis);
            const diffX = this.axis['Y'].x - (this.overallSelection.startX + this.overallSelection.width / 2)
            const diffY = this.axis['X'].y - (this.overallSelection.startY + this.overallSelection.height / 2)

            if(yAxis) {
              sel.setLeft(sel.x + diffX);
            } else {
              sel.setLeft(nextLeft);
            }
            if(xAxis) {
              sel.setTop(sel.y + diffY);
              // sel.setTop(nextTop);
            } else {
              sel.setTop(nextTop);
            }
          }

        }

        this.updateAllTransformControls()
      } else if (this.selecting) {
        let x, y, w, h;

        if (deltaX < 0) {
          x = e.clientX;
          w = this.dragStart.x - x;
        } else {
          x = this.dragStart.x;
          w = deltaX;
        }
        if (deltaY < 0) {
          y = e.clientY;
          h = this.dragStart.y - y;
        } else {
          y = this.dragStart.y;
          h = deltaY;
        }

        this.selection = {
          top: y,
          left: x,
          width: w,
          height: h,
          hidden: false
        };

        if (this.selectedElements) {
          this.selectedElements.forEach(se => se.hideTransformControls());
        }
        (this.selectedElements = this.toolbar.document.getElementsIn(
          this.selection
        )).forEach(e => e.showTransformControls());
      }
      this.updateOverallSelection();
    }
  }

  updateOverallSelection(visible) {
    let elems = this.getSelection();

    elems = elems.filter( ( el ) => !el.hasParent());

    if(!elems.length || elems.length <= 1) {
      this.overallSelection.visibility = "hidden";
      return;
    }

    const left = elems.reduce((memo, item) => {
      return item.x < memo.x ? item : memo;
    }, elems[0]).x;
    const top = elems.reduce((memo, item) => {
      return item.y < memo.y ? item : memo;
    }, elems[0]).y;
    const lright = elems.reduce((memo, item) => {
      return item.x + item.width > memo ? item.x + item.width : memo;
    }, elems[0].x + elems[0].width);
    const tbottom = elems.reduce((memo, item) => {
      return item.y + item.height > memo ? item.y + item.height : memo;
    }, elems[0].y + elems[0].height);

    // console.log(_x, _y, w, h);

    if (left && top) {
      const docPos = this.toolbar.document.getDocumentPosition();
      const x = docPos.x + left;
      const y = docPos.y + top;
      this.overallSelection = {
        startX: x,
        startY: y,
        width: lright - left,
        height: tbottom - top,
        visibility: "visible"
      };
    } else {
      this.overallSelection.visibility = "hidden";
    }
  }

  getSelection() {
    return this.selectedElements || [];
  }

  notifySelectionForResize(fromEl, e, d) {
    // const clone = (this.selectedElements || []).slice().splice(this.selectedElements.indexOf(fromEl), 1);
    let lol = this.getSelection().slice();
    lol.splice(0, 1);
    lol.forEach(e => e.handleResizeStart(e, d));
  }

  updateAllTransformControls() {
    this.getSelection().forEach(el => el.updateTransformControls());
  }

  select(element, doPush) {
    if (this.selectedElements.indexOf(element) === -1)
      this.dragging
        ? this.selectedElements.push(element)
        : (doPush ? this.selectedElements.push(element) : this.selectedElements = [element]);
    else {/*this.selectedElements.splice(this.selectedElements.indexOf(element), 1);*/}
    this.toolbar.document.notifyPanel("selectionChanged", this.selectedElements);
  }

  mouseUp(e) {
    if (this.dragging) {
      this.dragging = false;

      if (this.selecting) {
        this.selecting = false;
        this.comeFromSelection = true;
      }
      if (this.moving) this.moving = false;

      this.selection.hidden = true;
      this.showAxe("none");
    }
  }

  isSelectionAt(x, y) {
    const c = this.toolbar.document.props.parent;
    const cont = c.getActualContainer();
    x = x - cont.offsetLeft;
    y = y - cont.offsetTop;
    const normalized = {
      x: this.overallSelection.startX * c.zoom - cont.scrollLeft,
      y: this.overallSelection.startY * c.zoom - cont.scrollTop,
      width: this.overallSelection.width * c.zoom,
      height: this.overallSelection.height * c.zoom
    }
    return Utils.is(x, y).in(normalized) && this.overallSelection.visibility === "visible";
  }

  renderScaledAction() {
    const os = this.overallSelection.visibility === "visible" ? <div
      style={{
        position: "absolute",
        top: this.overallSelection.startY,
        left: this.overallSelection.startX,
        width: this.overallSelection.width,
        height: this.overallSelection.height,
        background: "rgba(71, 157, 249, .2)",
        border: "1px solid rgba(71, 157, 249, .5)",
        visibility: this.overallSelection.visibility,
        zIndex: 0
      }}
    /> : null;
    return (
      <React.Fragment key={54}>
        {os}
        {this.getAxis()}
      </React.Fragment>
    )
  }

  getAxis() {
    // const els = [];
    const doc = this.toolbar.document;
    const docPos = doc.getDocumentPosition();

    // console.log(doc.getProperty('size'));

    // X axis
    const xAxis = {
      x: docPos.x,
      y: docPos.y + doc.getProperty('size').value.height / 2,
      w: doc.getProperty('size').value.width,
      h: 1
    }

    const xAxisEl = (
      <div
        key={1}
        style={{
          position: 'absolute',
          left: xAxis.x,
          top: xAxis.y,
          width: xAxis.w,
          height: xAxis.h,
          background: 'red',
          visibility: this.showAxis.includes('X') ? "visible": "hidden"
        }}
      />
    )

    // Y axis
    const yAxis = {
      x: docPos.x + doc.getProperty('size').value.width / 2,
      y: docPos.y,
      w: 1,
      h: doc.getProperty('size').value.height
    }

    const yAxisEl = (
      <div
        key={2}
        style={{
          position: 'absolute',
          left: yAxis.x,
          top: yAxis.y,
          width: yAxis.w,
          height: yAxis.h,
          background: 'red',
          visibility: this.showAxis.includes('Y') ? "visible": "hidden"
        }}
      />
    )

    if(!this.axis) {
      this.axis = [];
      this.axis['X'] = xAxis;
      this.axis['Y'] = yAxis;
    }

    return [xAxisEl, yAxisEl]
  }

  renderAction() {
    return (
      <React.Fragment key={1}>
        <div
          style={{
            position: "absolute",
            top: this.selection.top,
            left: this.selection.left,
            width: this.selection.width,
            height: this.selection.height,
            background: "rgba(71, 154, 249, .2)",
            border: "1px solid rgb(71, 154, 249)",
            visibility: this.selection.hidden ? "hidden" : "visible"
          }}
        />
      </React.Fragment>
    );
  }

  renderTool() {
    return <polygon points="0,0 0,20 7,14 15,14" />;
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/tools/SelectionTool.js